module.exports = __webpack_public_path__ + "static/img/AISPlayApp.80a63b92.png";